/* 🤖 this file was generated by svg-to-ts */
export const matIconVideoCall: {
  name: 'video-call';
  data: string;
} = {
  name: 'video-call',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM15 16H5V8h10v8zm-6-1h2v-2h2v-2h-2V9H9v2H7v2h2z"/></svg>`
};
